<template>
  <div id="diagnostic-list">
    <header class="header">
      <div class="title">
        <h1>{{ $t("diagnostic.category.category") }}</h1>
      </div>

    </header>

    <div class="controls">
      <div>
        <label class="bolded">{{ $t("diagnostic.category.name") }}</label>
        <input type="text" v-model="name" />
      </div>
      <button @click="save('create')" type=" button" class="btn control upload-btn">{{ $t("diagnostic.category.add") }}</button>
    </div>


    <v-client-table :columns="table_options.columns" :options="table_options.options" :data="newsList">

      <template v-slot:actions="props">
        <div class="actions">

          <i @click="openEditModal('Editar categorías', 'edit',props)" class="icons-black far fa-edit"></i>

          <i @click="openDeleteModal('Eliminar categorías', 'delete',props)" class="far fa-trash-alt" ></i>
        </div>
      </template>
    </v-client-table>

    <Modal v-if="newModalActive" v-on:closeModal="closeModal">
      <div v-if="error">
            <b-alert
              v-model="error"
              variant="danger"
              dismissible
              id="alert-modal"
            >{{ textoError }}</b-alert>
      </div>
      <!-- Modal title -->
      <template #header>
        <span class="title">{{ $t("diagnostic.category.edit") }}</span>
      </template>
      <!-- Modal body -->
      <template>
        <div class="form-container">
          <!-- Name -->
          <div class="input-container">
            <label for="name">{{ $t("diagnostic.category.name") }}</label>
            <input type="text" id="name" name="name" v-model="nameEdit">
            <div class="error-msg">
            </div>
          </div>

        </div>
      </template>
      <!-- Modal footer -->
      <template #footer>
        <div class="modal-actions">
          <span class="cancel-btn" @click="newModalActive=false">{{ $t("global.cancel") }}</span>
          <button type="button" class="btn btn-dark save-btn" @click="save('')">{{ $t("global.save") }}</button>
        </div>
      </template>
    </Modal>



    <Modal v-if="deleteModal" v-on:closeModal="closeModal">

      <template #header>
        <h6 v-if="deleteModal" class="modal-title">
          Eliminar categoría
        </h6>
      </template>

      <template>
        <div v-if="deleteModal">
          <p>
            ¿Estás seguro de que deseas eliminar esta categoría?
          </p>
          <p>
            Esta acción no se puede deshacer.
          </p>
        </div>
      </template>

      <template #footer>
        <div v-if="deleteModal" class="controls">
          <span class="control cancel-btn" @click="closeDeleteModal">
            {{ $t("global.cancel") }}
          </span>

          <button
            type="button"
            class="btn-save"
            @click="deleteCategory(categoryId)"
          >
            Eliminar
          </button>
        </div>
      </template>

    </Modal>

  </div>

</template>

<script>
import API_SERVICE from "@/lib/api/Diagnostic.js";
import { ClientTable } from "vue-tables-2";
const Modal = () => import("@/components/Modal");
const api = new API_SERVICE();
export default {
  components: {
    ClientTable,
    Modal

  },
  methods: {
     getData:async function(){
      this.$store.commit("global/SET_LOADING", true);
    const resp = await api.getCategories(); 
    
    this.newsList=resp.data.items;
    
    this.$store.commit("global/SET_LOADING", false);

    },
    openEditModal: function (category, type,props) {
      this.error=false;
      const id=props.row.id;
      this.valorTurno=this.newsList.filter((data)=>data.id==id)[0];
      
      this.nameEdit=this.valorTurno.name;
      
      this.type = type;
      this.titleData = category;
      this.newModalActive = true;
    },
    openDeleteModal: function (category, type,props) {
      this.error=false;
      const id=props.row.id;
      
      this.type = type;
      this.titleData = category;
      this.categoryId = id;
      this.deleteModal = true;

    },
    save: async  function (type) { 
      this.$store.commit("global/SET_LOADING", true);     
      if (type != "") {
        if(this.name !=""){
          this.type = type;
          const resp = await api.saveCategories(this.name);     
          this.getData();
        }
      } else {
        if (!this.nameEdit) {
          this.error=true;
          this.textoError="Es necesario llenar todos los campos!";
        }else if(this.valorTurno.name==this.nameEdit){
          this.error=true;
          this.textoError="Campo no modificado";
        }else{
          this.error=false;
          await api.editCategories(this.nameEdit,this.valorTurno.id);  
          this.getData();
          this.newModalActive=false;
          this.nameEdit="";
        }
        
      }
      this.$store.commit("global/SET_LOADING", false);
      this.name="";
    },
    deleteCategory: async  function (id) { 
      this.$store.commit("global/SET_LOADING", true);     
      const resp = await api.deleteCategory(id);     
      this.getData();
      this.deleteModal = false;
      this.categoryId = 0;
      this.$store.commit("global/SET_LOADING", false);
    },
    closeModal: function () {
      this.newModalActive = false;
    },
  },
  data: function () {
    return {
      textoError:"",
      valorTurno:{},
      error:false,
      titleData: "",
      type: "create",
      name: "",
      nameEdit: "",
      newModalActive: false,
      deleteModal: false,
      categoryId: 0,
      newsList: [],
      modalActive: false,
      postToDelete: null,
      isLoading: false
    };
  },
  beforeMount: async function () {
    this.getData();
  },
  computed: {


    table_options: function () {
      return {

        columns: [
          "id",
          "name",
          "actions"
        ],
        options: {
          filterByColumn: true,
          filterable: this.table_filters,
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            id: "Id",
            name: "Categoria",
            actions: "Acciones"
          },
          sortable: [
            "id",
            "name"
          ],
          customSorting: {
            report: function (ascending) {
              return function (a, b) {
                if (ascending) {
                  return !a.hasCommentsReported ? 1 : -1;
                }
                return a.hasCommentsReported ? 1 : -1;
              };
            }
          },
          filterable: [],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            title: "title-column",
            report: "report-column",
            actions: "actions-column",
            updated_at: "updatedAt-column"
          },
          resizableColumns: false
        }
      };
    },

  },
}
</script>

<style>
.alert-modal {
  width: 100%;
}
.controls {
  display: flex;
  margin-bottom: 30px;
  margin-top: 30px;

}

.controls .upload-btn {
  background-color: #000;
  border-radius: 0px;
  color: #fff;
  margin-left: 1rem;
}

.controls .upload-btn:hover {
  color: #fff;
}

.title {
  font-weight: bold;
  font-size: 1.2rem;
}

.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  >* {
    margin-left: 1rem;
    cursor: pointer;
  }

  .cancel-btn {
    &:hover {
      text-decoration: underline;
    }
  }

  .save-btn {
    margin: 0 0 0 10px;
    color: white;
    background-color: black;
    border-color: black;
    padding: 10px 20px;
    border-radius: 0px;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  }
}
</style>